import Player from '@vimeo/player';

class Vimeo {
  stateClasses = {
    soundOn : 'sound-on',
  }
  constructor($el) {
    this.$el = $el;
    this.url = $el.data('url');
    this.$toggleSound = $el.find('[data-vimeo="toggle-sound"]');
    this.$video = $el.find('[data-vimeo="video"]');

    this.init();
  }

  init = () => {
    console.log('Vimeo', this);
    this.player = new Player(this.$video.get(0), {
      url: this.url,
      controls: false,
      autoplay: true,
      muted: true,
      loop: true,
    });

    this.$toggleSound.on('click', this.toggleSound);
    this.$video.on('click', this.togglePlay);
  }

  toggleSound = (e) => {
    e.preventDefault();

    this.player.getMuted().then((muted) => {
      if(muted) {
        this.player.setMuted(false);
        this.$el.addClass(this.stateClasses.soundOn);
      } else {
        this.player.setMuted(true);
        this.$el.removeClass(this.stateClasses.soundOn);
      }
    });
  }
}

export default Vimeo;